var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHdfcbank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.900146 0.899113H43.9678V43.9668H0.900146V0.899113Z",
    fill: "#ED232A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43811 8.43656H36.4351V36.4336H8.43811V8.43656Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2814 0.899113H24.5864V43.9668H20.2814V0.899113Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.900146 20.2867H43.9678V24.5918H0.900146V20.2867Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9763 15.9756H28.8971V28.8965H15.9763V15.9756Z",
    fill: "#004C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHdfcbank);
export default __webpack_public_path__ + "static/media/hdfcbank.7fbfa987d8a694215965d9ffa344561d.svg";
export { ForwardRef as ReactComponent };